import { createFileRoute, Link } from "@tanstack/react-router";
import { useState } from "react";
import { supabase } from "@/lib/supabase";
import { toast } from "sonner";

export const Route = createFileRoute("/confirm-email")({
  validateSearch: (s: Record<string, unknown>) => ({
    email: typeof s.email === "string" ? s.email : "",
  }),
  head: () => ({
    meta: [
      { title: "Check Your Email — Cailève" },
      { name: "description", content: "Confirm your email to activate your Cailève account." },
    ],
  }),
  component: ConfirmEmailPage,
});

function ConfirmEmailPage() {
  const { email } = Route.useSearch();
  const [busy, setBusy] = useState(false);

  async function resend() {
    if (!email) {
      toast.error("We don't have your email on file. Please sign up again.");
      return;
    }
    setBusy(true);
    const { error } = await supabase.auth.resend({
      type: "signup",
      email,
      options: { emailRedirectTo: `${window.location.origin}/login?confirmed=1` },
    });
    setBusy(false);
    if (error) toast.error(error.message);
    else toast.success("Confirmation email sent.");
  }

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4"
      style={{ backgroundColor: "var(--caileve-bg)" }}
    >
      <div className="w-full max-w-md text-center">
        <h1
          className="text-4xl mb-6"
          style={{
            fontFamily: "'Cormorant Garamond', Georgia, serif",
            color: "var(--caileve-ink)",
          }}
        >
          Check Your Email
        </h1>
        <p className="text-base leading-relaxed" style={{ color: "var(--caileve-ink)" }}>
          We've sent a confirmation link to{" "}
          <span style={{ color: "var(--caileve-lilac-text)" }}>{email || "your inbox"}</span>. One
          click and your collection awaits.
        </p>
        <button
          type="button"
          onClick={resend}
          disabled={busy}
          className="mt-8 text-sm hover:underline disabled:opacity-50"
          style={{ color: "var(--caileve-lilac-text)" }}
        >
          {busy ? "Sending…" : "Resend confirmation email"}
        </button>
        <div className="mt-10">
          <Link
            to="/login"
            className="text-xs uppercase tracking-[0.25em]"
            style={{ color: "var(--caileve-muted)" }}
          >
            Back to sign in
          </Link>
        </div>
      </div>
    </div>
  );
}